"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Time = _interopRequireDefault(require("@rsuite/icon-font/lib/time/Time"));

// Generated by script, don't edit it please.
var Time = (0, _createSvgIcon["default"])({
  as: _Time["default"],
  ariaLabel: 'time',
  category: 'time',
  displayName: 'Time'
});
var _default = Time;
exports["default"] = _default;
module.exports = exports.default;